import React, { FunctionComponent, CSSProperties, useRef, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";

import { Article } from '../app/types';


const titleStyle: CSSProperties = {
    margin: "5px",
    padding: "5px",
    borderStyle: "solid",
    borderRadius: "5px",
    borderColor: "black",
    borderWidth: "2px",
    fontSize: "25px",
    display: "inline-block",
    backgroundColor: "grey",
};

const selectedTitleStyle: CSSProperties = {
    margin: "5px",
    padding: "5px",
    borderStyle: "solid",
    borderRadius: "5px",
    borderColor: "black",
    borderWidth: "2px",
    fontSize: "25px",
    display: "inline-block",
    backgroundColor: "black",
}

interface ArticleNavItemProps {
    article: Article
}

export const ArticleNavItem: FunctionComponent<ArticleNavItemProps> = (props: ArticleNavItemProps) => {
    const navigate = useNavigate();
    const { articleID } = useParams();
    const ref = useRef(null);
    useEffect( () => {
        if (String(props.article.ID) === articleID) {
            ref.current.scrollIntoView({
                inline:'center',
                behavior: 'smooth',
                block: 'start',
            });
        }
    }, [articleID, props.article.ID]);

    const style = (String(props.article.ID) === articleID) ? selectedTitleStyle : titleStyle;

    return <span ref={ref}
        style={style}
        onClick={() => navigate("/article/" + props.article.ID)}>
        {props.article.name}
    </span>;
}
